import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import { AppBar, Toolbar, Box } from '@mui/material'
import { IconQrcode } from '@tabler/icons-react'
import { HEADER } from '../../config-global'
import { bgBlur } from '../../utils/cssStyles'
import Logo from '../../components/logo'
import { BackButton } from './BackButton'
import { useDomainContext } from '../../contexts/DomainContext'

Header.propTypes = {
    isOffset: PropTypes.bool,
}

export default function Header({ isOffset }) {

    const theme = useTheme()
    const { sucursal } = useDomainContext()

    return (
        <AppBar id="app-bar" color="transparent" sx={{ boxShadow: 0 }}>
            <Toolbar
                id='app-toolbar'
                sx={{
                    justifyContent: 'space-between',
                    height: {
                        xs: HEADER.H_MOBILE,
                        md: HEADER.H_MAIN_DESKTOP,
                    },
                    transition: theme.transitions.create(['height', 'background-color'], {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.shorter,
                    }),
                    ...(isOffset && {
                        ...bgBlur({ color: theme.palette.background.default }),
                        height: {
                            md: HEADER.H_MAIN_DESKTOP - 16,
                        },
                    }),
                }}
            >
                {sucursal ? (
                    <IconQrcode size={50} />
                ) : (
                    <Logo />
                )}
                <BackButton />
            </Toolbar>
            {isOffset && <Shadow />}
        </AppBar>
    );
}

Shadow.propTypes = {
    sx: PropTypes.object,
}

function Shadow({ sx, ...other }) {
    return (
        <Box
            sx={{
                left: 0,
                right: 0,
                bottom: 0,
                height: 24,
                zIndex: -1,
                m: 'auto',
                borderRadius: '50%',
                position: 'absolute',
                width: `calc(100% - 48px)`,
                boxShadow: (theme) => theme.customShadows.z8,
                ...sx,
            }}
            {...other}
        />
    )
}


